var HttpMethods = {
	GET: 'get',
    POST: 'post',
    PUT: 'put',
    DELETE: 'delete'
};

module.exports = HttpMethods;



// WEBPACK FOOTER //
// ./src/enums/HttpMethods.js